"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const Parking = _ref => {
  let {
    title = 'Parking',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22,0 C23.1045695,-2.02906125e-16 24,0.8954305 24,2 L24,22 C24,23.1045695 23.1045695,24 22,24 L2,24 C0.8954305,24 1.3527075e-16,23.1045695 0,22 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L22,0 Z M13.1929647,3.69230769 L6.15384615,3.69230769 L6.15384615,19.6923077 L10.3949426,19.6923077 L10.3949426,14.1410686 L13.1929647,14.1410686 C15.2859622,14.1410743 16.8906006,13.6909743 18.0068847,12.7907672 C19.130484,11.8834296 19.6923077,10.5902852 19.6923077,8.91132979 C19.6923077,7.23954053 19.130484,5.95354039 18.0068847,5.05332572 C16.8906006,4.14599586 15.2859622,3.69230769 13.1929647,3.69230769 L13.1929647,3.69230769 Z M12.5217691,6.45092838 C13.369806,6.45092838 14.0247702,6.64146447 14.4866632,7.0224987 C14.9485345,7.40355747 15.1794872,7.94690165 15.1794872,8.65253258 C15.1794872,9.35818488 14.9485345,9.90505719 14.4866632,10.2931512 C14.0247702,10.6742066 13.369806,10.8647215 12.5217691,10.8647215 L12.5217691,10.8647215 L10.1025641,10.8647215 L10.1025641,6.45092838 Z"
  }));
};
var _default = exports.default = (0, _ikon.default)(Parking);
Parking.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Parking",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Parking'",
        "computed": false
      },
      "required": false
    }
  }
};